import React, { Component } from 'react';
import styled from 'styled-components';
import RecordButton, { Arrow } from '../components/buttons/record';
import VoxButton from '../components/buttons/vox-button';
import { PreFooter } from '../components/page';
import { POPUP_TYPE } from '../components/popup';
import { tspan } from '../utils/i18n';
import isMobile from '../utils/mobilecheck';
import {TitleText} from './start';
import { faMicrophone as solidMic, faLock as lock } from "@fortawesome/pro-solid-svg-icons";
import {faMicrophone as regularMic} from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {HexagonSmall} from "../components/hexagon";
import SendVox from '../components/buttons/send';
import {MicImage, StartContainer} from "./start";


const LargeMic = styled(FontAwesomeIcon)`
  font-size: 96px;
  line-height: 96px;
  display: flex;
  align-items: center;
  text-align: center;
  text-transform: capitalize;
  color: #C4C4C4;
`;

export const ColoredFooter = styled.div`
    height: 100%;
    width: 100%;
    margin-bottom: 5px !important;
    background: ${props => (!props.requiredShadow && props.hideGreyBar) ? '#FFFFFF' : '#F1F1F1'};
    display: flex;
    flex-direction: initial !important;
    justify-content: center;
    align-items: center;
    position: relative;
    >:first-child {
        cursor: pointer;
    }

`;

export default class MicCheck extends Component {
    static propTypes = {

    };

    static nextPage = 'recording';

    state = {
        micGranted: false,
        showCTA: false,
        processing: true
    };

    async componentDidMount() {
        const { onSwitch, showPopup, micAllowed } = this.props;
        const { processing } = this.state;

        const checkTimer = setTimeout(() => {
            this.setState({ processing: false });
        }, 500);

        if (micAllowed) {
            // If we have access from before, just move on
            // NOTE: Due to UX requirements, the mic allowed
            // on a previous page was removed, so we need to handle
            // Requesting permission, or moving on in a different way
            onSwitch(MicCheck.nextPage);
        } else {
            // Wait for permission, and if denied, show the error popup
            try {
                await navigator.mediaDevices.getUserMedia({ audio: true });

                // Still processing means the timeout didn't fire
                if (processing) {
                    // Clear the timer
                    clearTimeout(checkTimer);
                    onSwitch(MicCheck.nextPage);
                } else {
                    // Once granted, ask for intertction to begin recording
                    this.setState({ micGranted: true, showCTA: true, processing: false });
                }
            } catch (err) {
                showPopup(isMobile.any() ? POPUP_TYPE.mobile : POPUP_TYPE.desktop);
            }
        }
    }

    render() {
      const { micGranted, showCTA, processing } = this.state;
      const { onSwitch, settings } = this.props;
      const { common } = this.props.settings;
        return (
        <>
          <StartContainer className="content" settings={settings}>
              <div className="plugin-header">
            <div className="title">
                <div
                    style={{
                        fontStyle: 'normal',
                        fontFamily: 'Titillium Web',
                        fontWeight: 'bold',
                        fontSize: '16px',
                        lineHeight: '24px',
                        color:'#27364E',
                        verticalAlign: 'middle'
                    }}>
                    {micGranted
                        ? tspan('welcomeTitle')
                        : processing
                            ? tspan('mic-check-prepare')
                            : tspan('mic-check-allow')}
                </div>
            </div>
              </div>
              <div className="sub-title"
                   style={{
                       fontStyle: 'normal',
                       fontFamily: 'Titillium Web',
                       fontWeight: 'normal',
                       fontSize: '15px',
                       lineHeight: '23px',
                       color:'#27364E',
                       margin:'10px',
                   }}>
                  {micGranted ?
                      tspan('welcomeSubTitle', { button: <MicImage> <HexagonSmall
                              common={common} icon={solidMic}
                              micPermission={micGranted}/> </MicImage>})
                      : processing
                          ? tspan('mic-check-prepare-sub')
                          : tspan('mic-check-allow-sub')}
              </div>
          {!micGranted && (
            <div style={{ margin: 'auto',
                maxheight:'67px',
                zIndex: 2,
                padding: '10px'}}>
                <LargeMic icon={regularMic}/>
            </div>
        )}
          </StartContainer>
        <p style={{
                fontFamily: 'Lato',
                fontSstyle: 'normal',
                fontWeight: 'normal',
                fontSize: '10px',
                lineHeight: '12px',
                color: '#858C9A',
                marginBottom: '0.375rem',
            }}>{micGranted && 'Press to begin recording'}</p>
          {micGranted && showCTA ? (
            <PreFooter>
              <Arrow />
            </PreFooter>
          ) : null}
          <ColoredFooter className="buttons" requiredShadow={common.requiredShadow} hideGreyBar={common.hideGreyBar}>
            {showCTA ? (
              <RecordButton common={common} arrow={false} onClick={() => onSwitch(MicCheck.nextPage)} icon={solidMic} micPermission={micGranted}/>
            ) : (
              <SendVox common={common} icon={lock} processing={processing} micPermission={micGranted}/>
            )}
          </ColoredFooter>
        </>
      );
    }
}
